import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import "./sidebar.css";
import logoutIcon from "../../img/logout.png";
import userIcon from "../../img/User Management.svg";
import dashboardIcon from "../../img/Dashboard.svg";
import carIcon from "../../img/Vehicle Management.svg";
import vendorIcon from "../../img/Transporter Management.svg";
import siteIcon from "../../img/Site Management.svg";
import routeIcon from "../../img/Route Management.svg";
import tripIcon from "../../img/Trip Management.svg";
// import dashboardIcon from '../../img/dashboard.png'
import reportIcon from "../../img/Reports.svg";
import GpsIcon from "../../img/GPS report.png";
import RunningIcon from "../../img/Running Report.png";
import StoppageIcon from "../../img/Stoppage report.png";
import AllTripIcon from "../../img/All trip report.png";
import SummaryIcon from "../../img/Summary report.png";
import DelayedIcon from "../../img/Delayed report.png";
import TemparingIcon from "../../img/Tempering report.png";
import OverSpeedIcon from "../../img/Over speed report.png";
import NearestVehicleIcon from "../../img/Nearest vehicle report.png";
import RouteDevationIcon from "../../img/Route Deviation report.png";
import TrackHistoryIcon from "../../img/Track History.svg";
import fuelDashboardIcon from "../../img/fueldashboard.png";
import fuelIcon from "../../img/FuelReport.png";
import fuelFillIcon from "../../img/Fuelfillreport.png";
import fuelDroppageIcon from "../../img/Fueldroppagereport.png";
import fuelmanagementIcon from "../../img/Fuel Management.svg";
import activeLogIcon from "../../img/Activelog.svg";
import DealerDetails from "../../img/dealer.svg";
import ActivationRenewal from "../../img/Activtion renewal.svg";

import activeRouteIcon from "../../img/ActiveRoutes.png";
import uptimeIcon from "../../img/Uptimereport.png";
import notificationIcon from "../../img/Notification Configuration.svg";
import subscriptionIcon from "../../img/subscribe.svg";
import companyIcon from "../../img/company.svg";

import { version } from "../../config/config";
import { ContactsOutlined } from "@material-ui/icons";
import { themeContext } from "../../App";
function Sidebar() {
  const { color } = useContext(themeContext);
  const history = useHistory();
  const userType = JSON.parse(localStorage.getItem("data")).userType;
  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(localStorage.getItem("data"))
  );
  const [parentMenuColor, setParentMenuColor] = React.useState(false);
  console.log(permissionAccess);
  const viewAllUserPermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "USER_MENU"
  );
  const viewAllSitePermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "SITE_MENU"
  );
  const viewAllRoutePermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "ROUTE_MENU"
  );
  const viewAllSubcritionMaster =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "SUBCRITION_MASTER"
    );
  const viewAllVehiclePermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "VEHICLE_MENU"
    );
  const viewAllVendorPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "VENDOR_MENU"
    );
  const viewAllTripPermission = permissionAccess?.webPermissionDTOList?.filter(
    (order) => order.name === "GET_ALL_TRIP"
  );
  const viewAllReportPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ALL_REPORT"
    );
  const viewAllReportAuditPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_AUDIT_LOG_REPORT"
    );
  const viewAllReportActiveRoutesPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "GET_ACTIVE_ROUTES"
    );
  const viewAllDealerLedgerPermission =
    permissionAccess?.webPermissionDTOList?.filter(
      (order) => order.name === "DEALER_LEDGER"
    );

  let dashboardMenu = true;
  let userMenu = true;
  let companyMenu = false;
  let vendorMenu = true;
  let vehicleMenu = true;
  let siteMenu = true;
  let routeMenu = true;
  let SubscriptionMaster = true;
  let trackMenu = true;
  let tripMenu = true;
  let reportMenu = true;
  let fuelMenu = true;
  let fuelReport = true;
  let notificationMenu = true;
  let sidemenu = true;
  let kycMenu = true;
  let dealerLedger = true;
  let activationRenewal = true;
  let UpdateActivationRenewal = true;

  if (permissionAccess && permissionAccess.menuVisiblity) {
    permissionAccess &&
      permissionAccess?.menuVisiblity?.forEach((element) => {
        if (element.name == "DASHBOARD") {
          dashboardMenu = element.isVisible;
        }
        if (element?.name == "USER_MANAGEMENT") {
          userMenu = element.isVisible;
        }
        if (element?.name === "COMPANY_MANAGEMENT") {
          companyMenu = element.isVisible;
        }
        if (element.name == "TRANSPORTER_MANAGEMENT") {
          vendorMenu = element.isVisible;
        }
        if (element.name == "VEHICLE_MANAGEMENT") {
          vehicleMenu = element.isVisible;
        }
        if (element.name == "SITE_MANAGEMENT") {
          siteMenu = element.isVisible;
        }
        if (element.name == "ROUTE_MANAGEMENT") {
          routeMenu = element.isVisible;
        }
        if (element.name == "TRACK_HISTORY") {
          trackMenu = element.isVisible;
        }
        if (element.name == "SUBCRITION_MASTER") {
          SubscriptionMaster = element.isVisible;
        }
        if (element.name == "TRIP_MANAGEMENT") {
          tripMenu = element.isVisible;
        }
        if (element.name == "FUEL_MANAGEMENT") {
          fuelMenu = element.isVisible;
        }
        if (element.name == "FUEL_MANAGEMENT") {
          fuelReport = element.isVisible;
        }
        if (element.name == "REPORTS") {
          reportMenu = element.isVisible;
        }
        if (element.name == "NOTIFICATION CONFIGURATION") {
          notificationMenu = element.isVisible;
        }
        if (element.name == "MENU_MANAGEMENT") {
          sidemenu = element.isVisible;
        }
        if (element.name == "DEALER_LEDGER") {
          dealerLedger = element.isVisible;
        }
        if (element.name == "ACTIVATION_RENEWAL") {
          activationRenewal = element.isVisible;
        }
        if (element.name == "UPDATE_ACTIVATION_RENEWAL") {
          UpdateActivationRenewal = element.isVisible;
        }
      });
  }

  // sub menu visibility Oct 13th 2022
  // for fuel management->fuelreports
  let fuelSummaryReport = true;
  let sensorCutVehicles = true;
  let fuelFillReport = true;
  let fuelDroppageReport = true;
  let gpsWirecutReport = true;
  let fuelGraphMisReport = true;
  let fuelEffiencyMisReport = true;
  let expectedVsActualReport = true;
  let fuelConsumptionReport = true;
  let fuelMisReport = true;
  let alertMisReport = true;
  let combineFuelReport = true;
  let dieselIssue = true;
  //for reports
  let summaryReport = true;
  let movementReport = true;
  let stoppageReport = true;
  let overSpeedReport = true;
  let geofenceReport = true;
  let routeDeviationReport = true;
  let tamperingReport = true;
  let auditLog = true;
  let activeRoutes = true;
  let gpsReport = true;

  // for usermanagement-> dealer && customer submenu
  let dealerMenu = true;
  let customerMenu = true;

  if (permissionAccess && permissionAccess.subMenuVisibilty) {
    permissionAccess &&
      permissionAccess?.subMenuVisibilty.forEach((element) => {
        if (element.name === "FUEL_SUMMARY_REPORT") {
          fuelSummaryReport = element.isVisible;
        } else if (element.name === "SENSOR_CUT_VEHICLES") {
          sensorCutVehicles = element.isVisible;
        } else if (element.name === "FUEL_FILL_REPORT") {
          fuelFillReport = element.isVisible;
        } else if (element.name === "FUEL_DROPPAGE_REPORT") {
          fuelDroppageReport = element.isVisible;
        } else if (element.name === "FUEL_WIRECUT_REPORT") {
          gpsWirecutReport = element.isVisible;
        } else if (element.name === "FUEL_GRAPH_MIS_REPORT") {
          fuelGraphMisReport = element.isVisible;
        } else if (element.name === "FUEL_EFFICIENCY_MIS_REPORT") {
          // fuel spelling mistake in api
          fuelEffiencyMisReport = element.isVisible;
        } else if (element.name === "EXPECTED_VS_ACTUAL_REPORT") {
          expectedVsActualReport = element.isVisible;
        } else if (element.name === "FUEL_CONSUMPTION_REPORT") {
          fuelConsumptionReport = element.isVisible;
        } else if (element.name === "FUEL_MIS_REPORT") {
          fuelMisReport = element.isVisible;
        } else if (element.name === "ALERT_MIS_REPORT") {
          // - instead of _ in api
          alertMisReport = element.isVisible;
        } else if (element.name === "COMBINE_FUEL_REPORT") {
          combineFuelReport = element.isVisible;
        } else if (element.name === "DIESEL_ISSUE") {
          dieselIssue = element.isVisible;
        }
        // for reports
        else if (element.name === "SUMMARY_REPORT") {
          summaryReport = element.isVisible;
        } else if (element.name === "MOVEMENT_REPORT") {
          movementReport = element.isVisible;
        } else if (element.name === "STOPPAGE_REPORT") {
          stoppageReport = element.isVisible;
        } else if (element.name === "OVER_SPEED_REPORT") {
          overSpeedReport = element.isVisible;
        } else if (element.name === "GEOFENCE_REPORT") {
          geofenceReport = element.isVisible;
        } else if (element.name === "ROUTE_DEVIATION_REPORT") {
          routeDeviationReport = element.isVisible;
        } else if (element.name === "TAMPERING_REPORT") {
          tamperingReport = element.isVisible;
        } else if (element.name === "AUDIT_LOG") {
          auditLog = element.isVisible;
        } else if (element.name === "ACTIVE_ROUTES") {
          activeRoutes = element.isVisible;
        } else if (element.name === "GPS_REPORT") {
          gpsReport = element.isVisible;
        } else if (element.name === "DEALER_MANAGEMENT") {
          dealerMenu = element.isVisible;
        } else if (element.name === "CUSTOMER_MANAGEMENT") {
          customerMenu = element.isVisible;
        }
      });
  }

  const handleLogout = async () => {
    window.open(`/`, "_self");
    window.localStorage.clear();
  };

  const handleClick = (value) => {
    localStorage.removeItem("payloadForDroppage");
    localStorage.setItem("fuelDetailsState", JSON.stringify(false));
    history.push(`/${value}`);
    window.open(`/${value}`, "_self");
  };

  const mouseOutHandler = () => {
    let id1 = document.getElementsByClassName("dropdownFuel")[0]; //Fuel management
    let id2 = document.getElementsByClassName("dropdownFuel")[1]; // fuel management > Fuel report
    let id3 = document.getElementsByClassName("fuelMenuDashBoard")[0]; // fuel management > Dashboard
    id1.classList.remove("my-class");
    id2.classList.remove("my-class");
    id3.classList.remove("my-class");
  };

  const mouseOverHandler = () => {
    let id1 = document.getElementsByClassName("dropdownFuel")[0];
    let id2 = document.getElementsByClassName("dropdownFuel")[1];
    let id3 = document.getElementsByClassName("fuelMenuDashBoard")[0];

    id1.classList.add("my-class");
    id2.classList.add("my-class");
    id3.classList.add("my-class");
    setParentMenuColor(true);

    id2.addEventListener("mouseover", () => {
      id1.classList.add("my-class");
      const fuelReportSubmenusArray =
        document.getElementsByClassName("fuelReportSubmenu");
      console.log(fuelReportSubmenusArray);
      for (const subMenuUnit of fuelReportSubmenusArray) {
        subMenuUnit.addEventListener("mouseover", () => {
          subMenuUnit.classList.add("my-class_with-border");
          id1.classList.add("my-class");
          id2.classList.add("my-class");
          id3.classList.add("my-class");
        });
        subMenuUnit.addEventListener("mouseout", () => {
          subMenuUnit.classList.remove("my-class_with-border");
          id1.classList.remove("my-class");
          id2.classList.remove("my-class");
          id3.classList.remove("my-class");
        });
        subMenuUnit.classList.add("my-class", "shift_right");
      }

      const fuellevel1 = document.getElementsByClassName("fuelMenuDashBoard");
      for (const fuelinit1 of fuellevel1) {
        fuelinit1.addEventListener("mouseover", () => {
          fuelinit1.classList.add("my-class_with-border");
        });
        fuelinit1.addEventListener("mouseout", () => {
          fuelinit1.classList.remove("my-class_with-border");
        });
        fuelinit1.classList.add("my-class", "shift_right");
      }
    });
  };

  // const reportDropDown = document.getElementById("reportMenuBar");
  // console.log(reportDropDown)

  // reportDropDown.addEventListener("mouseover",()=>{
  //     let reportSubMenus=document.getElementsByClassName("reportSubMenu")

  //     for (const subMenuElement of reportSubMenus) {
  //         subMenuElement.classList.add("my-class_with-border")
  //     }
  // })

  const mouseOutHandlerForReports = () => {
    // let reportmainMenu=document.getElementsByClassName("dropdown")[0]
    // reportmainMenu.classList.remove("my-class")
  };

  const mouseOverForReportHandler = () => {
    let reportmainMenu = document.getElementsByClassName("dropdown")[0];
    reportmainMenu.classList.add("my-class");

    let reportSubMenuContainer =
      document.getElementsByClassName("showDivReport")[0];

    let reportSubMenus = document.getElementsByClassName("reportSubMenu");

    for (const subReportUnit of reportSubMenus) {
      subReportUnit.addEventListener("mouseover", () => {
        reportSubMenuContainer.classList.add("my-class");
        subReportUnit.classList.add("only-border");
      });
      subReportUnit.addEventListener("mouseout", () => {
        subReportUnit.classList.remove("only-border");
      });
    }

    // reportSubMenuContainer.addEventListener("mouseover",()=>{

    // })
    reportSubMenuContainer.addEventListener("mouseout", () => {
      reportmainMenu.classList.remove("my-class");
    });
  };

  // const handleMouseOverAddClass = () => {
  //     alert('Hey')
  // }

  // let navLinkHover = document.getElementsByClassName("navlink")
  // let dropdownNavLinkHover = document.getElementsByClassName("dropdownFuel")

  // for (const navLinkHoverItem of navLinkHover) {
  //     navLinkHoverItem.addEventListener("mouseover",()=>{
  //         navLinkHoverItem.classList.add("only-left-border")

  //     })
  //     navLinkHoverItem.addEventListener("mouseout",()=>{
  //         navLinkHoverItem.classList.remove("only-left-border")
  //     })
  // }

  return (
    <div className="sidebar" style={{ zIndex: "999", background: color }}>
      {localStorage.getItem("email") != "route@watsoo.com" && (
        <ul className="top-menu">
          {true && (
            <li className="navlink" onClick={() => handleClick("VehicleDashboard")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] === "VehicleDashboard"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={dashboardIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Dashboard{" "}
                </div>
              </div>
            </li>
          )}
          {userMenu ? (
            <li
              className="navlink dropdownUser"
              //onClick={() => handleClick("userlist")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "userlist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  User Management{" "}
                </div>
              </div>

              {/* USER SUB MENU START */}
              {/* Dealer and Customer Submenu Oct 31 condition to be set later*/}
              <ul className="showDivUser" onClick={(e) => e.stopPropagation()}>
                {/* for dealer */}
                {dealerMenu ? (
                  <li
                    className="navlink"
                    onClick={(e) => handleClick("subuserlist?userType=dealer")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            new URLSearchParams(
                              window.location.search.replace("?", "")
                            ).get("userType") == "dealer"
                              ? 1
                              : 1,
                        }}
                        className="ml-1"
                        src={userIcon}
                        alt="User"
                      />
                      <div className="text-white ml-2 font-weight-bolder">
                        Dealer Management{" "}
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}

                {/* for customer */}
                {customerMenu ? (
                  <li
                    className="navlink"
                    onClick={(e) =>
                      handleClick("subuserlist?userType=customer")
                    }
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            new URLSearchParams(
                              window.location.search.replace("?", "")
                            ).get("userType") == "customer"
                              ? 1
                              : 1,
                        }}
                        className="ml-1"
                        src={userIcon}
                        alt="User"
                      />
                      <div className="text-white ml-2 font-weight-bolder">
                        Customer Management{" "}
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}
              </ul>

              {/* USER SUB MENU END */}
            </li>
          ) : (
            ""
          )}
          {/* role management */}
          {dealerLedger ? (
            <li
              className="navlink "
              onClick={() => handleClick("dealerLedger")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "dealerLedger"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={DealerDetails}
                  alt="dealerLedger"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Dealer Ledger{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {/* role management */}
          {viewAllUserPermission &&
          viewAllUserPermission.length > 0 &&
          sidemenu ? (
            <li className="navlink " onClick={() => handleClick("rolelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "userlist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Menu Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {/* end */}

          {/* company management sept 5 */}
          {companyMenu &&
            localStorage.getItem("data") &&
            JSON.parse(localStorage.getItem("data")).userType.toUpperCase() ===
              "SUPER_ADMIN" && (
              <li
                className="navlink "
                onClick={() => handleClick("companylist")}
              >
                <div className="innerList">
                  <img
                    style={{
                      opacity:
                        window.location.pathname.split("/")[1] == "companylist"
                          ? 1
                          : 1,
                    }}
                    className="ml-1"
                    src={companyIcon}
                    alt="Company"
                  />
                  <div className="text-white ml-2 font-weight-bolder">
                    Company Management{" "}
                  </div>
                </div>
              </li>
            )}
          {/* company management end */}

          {false && viewAllVendorPermission.length > 0 && vendorMenu ? (
            <li
              className="navlink "
              onClick={() => handleClick("transporterlist")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "transporterlist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={vendorIcon}
                  alt="Transporter"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Transporter Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {vehicleMenu ? (
            <li className="navlink " onClick={() => handleClick("vehiclelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "vehiclelist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={carIcon}
                  alt="vehicle"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Vehicle Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {/* for customer */}
          {/* {kycMenu ? (
            <li className="navlink" onClick={(e) => handleClick("kycMaster")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      new URLSearchParams(
                        window.location.search.replace("?", "")
                      ).get("userType") == "customer"
                        ? 1
                       : 1,
                  }}
                  className="ml-1"
                  src={userIcon}
                  alt="User"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  KYC Master{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )} */}
          {userType !== "CUSTOMER" && activationRenewal && false ? (
            <li
              className="navlink"
              onClick={(e) => handleClick("activationRenewalList")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      new URLSearchParams(
                        window.location.search.replace("?", "")
                      ).get("userType") == "customer"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={ActivationRenewal}
                  alt="activationRenewalList"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Activation/Renewal{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {false && viewAllSitePermission.length > 0 && siteMenu ? (
            <li className="navlink " onClick={() => handleClick("sitelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "sitelist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1 pl-1"
                  src={siteIcon}
                  alt="site"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Site Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {viewAllRoutePermission &&
          viewAllRoutePermission.length > 0 &&
          routeMenu ? (
            <li className="navlink " onClick={() => handleClick("routelist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "routelist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={routeIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Route Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}
          {SubscriptionMaster ? (
            <li
              className="navlink "
              onClick={() => handleClick("SubscriptionMaster")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "SubscriptionMaster"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={subscriptionIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Subscription Master{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {trackMenu && (
            <li className="navlink " onClick={() => handleClick("history/0")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "history"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={TrackHistoryIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Track History{" "}
                </div>
              </div>
            </li>
          )}
          {false && (
            <li
              className="navlink "
              onClick={() => handleClick("VehicleActivation")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "VehicleActivation"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={TrackHistoryIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Vehicle Activation{" "}
                </div>
              </div>
            </li>
          )}
          {viewAllTripPermission &&
          viewAllTripPermission.length > 0 &&
          tripMenu ? (
            <li className="navlink " onClick={() => handleClick("triplist")}>
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "triplist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={tripIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Trip Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {false ? (
            <li
              className="navlink "
              onClick={() => handleClick("subscriptionMasterList")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] ==
                      "/subscriptionMasterList"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={notificationIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Subscription Management{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {false && viewAllTripPermission.length > 0 && notificationMenu ? (
            <li
              className="navlink "
              onClick={() => handleClick("notificationConfigure")}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "triplist"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={notificationIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Notification Configuration{" "}
                </div>
              </div>
            </li>
          ) : (
            ""
          )}

          {false && viewAllReportPermission.length > 0 && fuelMenu && (
            <li
              className="navlink dropdownFuel"
              onMouseOut={mouseOutHandler}
              style={parentMenuColor ? { color: "orange" } : { color: "white" }}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "fuelreport" &&
                      window.location.pathname.split("/")[1] == "fuelDashboard"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={fuelmanagementIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Fuel Management{" "}
                </div>
              </div>

              {/* DropDown */}

              <ul className="showDivFuel" style={{ background: color }}>
                <li
                  className="text-white navlink fuelMenuDashBoard"
                  onClick={() => handleClick("fuelDashboard")}
                >
                  <div className="innerList">
                    <img
                      style={{
                        opacity:
                          window.location.search.split("?")[1] ==
                          "type=fuelDashboard"
                            ? 1
                            : 1,
                      }}
                      src={dashboardIcon}
                      alt="route"
                    />
                    <div className="text-white ml-1 pl-3 font-weight-bolder">
                      {" "}
                      Fuel Dashboard{" "}
                    </div>
                  </div>
                </li>
                {dieselIssue && (
                  <li
                    className="text-white navlink fuelMenuDashBoard"
                    onClick={() => handleClick("Diesel_issue")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Diesel_issue"
                              ? 1
                              : 1,
                        }}
                        src={fuelmanagementIcon}
                        alt="route"
                      />
                      <div className="text-white ml-1 pl-3 font-weight-bolder">
                        {" "}
                        Diesel Issue
                      </div>
                    </div>
                  </li>
                )}

                {viewAllReportPermission.length > 0 && fuelReport && (
                  <li className="navlink dropdownFuel fuelMenuDashBoard text-white">
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.pathname.split("/")[1] ==
                              "fuelreport" ||
                            window.location.pathname.split("/")[1] ==
                              "fuelreport"
                              ? 1
                              : 1,
                        }}
                        className="ml-1"
                        src={fuelmanagementIcon}
                        alt="route"
                      />
                      <div className="text-white ml-1 pl-3 font-weight-bolder">
                        Fuel Reports{" "}
                      </div>
                    </div>
                    <ul
                      className="innerShowDivFuel"
                      style={{ background: color }}
                    >
                      {fuelFillReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELFILL")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELFILL"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Fill Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelDroppageReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELDROP")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELDROP"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Droppage Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {gpsWirecutReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELWIRECUT")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELWIRECUT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Gps Wirecut Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {sensorCutVehicles &&
                        localStorage.getItem("getsensordata") && (
                          <li
                            className="text-white navlink fuelReportSubmenu"
                            onClick={() =>
                              handleClick("fuelreport?type=SENSORWIRECUT")
                            }
                          >
                            <div className="innerList">
                              <img
                                style={{
                                  opacity:
                                    window.location.search.split("?")[1] ==
                                    "fuelreport?type=SENSORWIRECUT"
                                      ? 1
                                      : 1,
                                }}
                                src={reportIcon}
                                alt="route"
                              />
                              <div className="text-white pl-4 font-weight-bolder">
                                Sensor Wirecut Report
                              </div>
                            </div>
                          </li>
                        )}
                      {fuelSummaryReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=FUELSUMMARY")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELSUMMARY"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              Fuel Summary Report{" "}
                            </div>
                          </div>
                        </li>
                      )}

                      {/* {localStorage.getItem("getsensordata") && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() => handleClick("SensorWirecut")}
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=SensorWirecut"
                                    ? 1
                                   : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Sensor Cut Vehicles
                            </div>
                          </div>
                        </li>
                      )} */}

                      {fuelGraphMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() => handleClick("fuelDetails/0")}
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELGRAPH"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Graph MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelEffiencyMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELEFFICIENCY&subType=FEMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELEFFICIENCY&subType=FEMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Efficiency MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {expectedVsActualReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELALERT&subType=EVAFMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELALERT&EVAFMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Expected Vs Actual Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelConsumptionReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELSUMMARY&subType=KMDMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELSUMMARY&subType=KMDMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel Consumption Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {fuelMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELSUMMARY&subType=FUELMISREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELSUMMARY&subType=FUELMISREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Fuel MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {alertMisReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick("fuelreport?type=alertType")
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=ODOMETER"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Alert MIS Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                      {combineFuelReport && (
                        <li
                          className="text-white navlink fuelReportSubmenu"
                          onClick={() =>
                            handleClick(
                              "fuelreport?type=FUELFILLDROPCOMBINEDREPORT"
                            )
                          }
                        >
                          <div className="innerList">
                            <img
                              style={{
                                opacity:
                                  window.location.search.split("?")[1] ==
                                  "type=FUELFILLDROPCOMBINEDREPORT"
                                    ? 1
                                    : 1,
                              }}
                              src={reportIcon}
                              alt="route"
                            />
                            <div className="text-white pl-4 font-weight-bolder">
                              {" "}
                              Combine Fuel Report{" "}
                            </div>
                          </div>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              </ul>
              {/* DropDownEnd */}
            </li>
          )}
          {reportMenu && (
            <li
              className="navlink dropdown dropdownFuel"
              id="reportMenuBar"
              onMouseOut={mouseOutHandlerForReports}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "reportsgps" ||
                      window.location.pathname.split("/")[1] == "reports"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={ActivationRenewal}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Activation/Renewal{" "}
                </div>
              </div>
              <ul className="showDivFuel" style={{ background: color }}>
                {activationRenewal && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("activationRenewalList")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Summary"
                              ? 1
                              : 1,
                        }}
                        src={SummaryIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Activation/Renewal Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {UpdateActivationRenewal && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("updateDate")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Summary"
                              ? 1
                              : 1,
                        }}
                        src={SummaryIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Update Activation/Renewal{" "}
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </li>
          )}

          {reportMenu && (
            <li
              className="navlink dropdown dropdownFuel"
              id="reportMenuBar"
              onMouseOut={mouseOutHandlerForReports}
            >
              <div className="innerList">
                <img
                  style={{
                    opacity:
                      window.location.pathname.split("/")[1] == "reportsgps" ||
                      window.location.pathname.split("/")[1] == "reports"
                        ? 1
                        : 1,
                  }}
                  className="ml-1"
                  src={reportIcon}
                  alt="route"
                />
                <div className="text-white ml-2 font-weight-bolder">
                  Reports{" "}
                </div>
              </div>
              <ul className="showDivFuel" style={{ background: color }}>
                {summaryReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("Summary")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Summary"
                              ? 1
                              : 1,
                        }}
                        src={SummaryIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Summary Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {movementReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("Movement")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=running"
                              ? 1
                              : 1,
                        }}
                        src={RunningIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Movement Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {stoppageReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=Stoppage")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Stoppage"
                              ? 1
                              : 1,
                        }}
                        src={StoppageIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Stoppage Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {overSpeedReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=overspeed")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=overspeed"
                              ? 1
                              : 1,
                        }}
                        src={OverSpeedIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Over Speed Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {geofenceReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=GeoFenceDetail")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=GeoFenceDetail"
                              ? 1
                              : 1,
                        }}
                        src={OverSpeedIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Geofence Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {routeDeviationReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=routedeviation")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=routedeviation"
                              ? 1
                              : 1,
                        }}
                        src={RouteDevationIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Route Deviation Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {tamperingReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reports?type=Tampering")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] ==
                            "type=Tempering"
                              ? 1
                              : 1,
                        }}
                        src={TemparingIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Tampering Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {auditLog &&
                  viewAllReportAuditPermission &&
                  viewAllReportAuditPermission.length > 0 && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("audit")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] == "audit"
                                ? 1
                                : 1,
                          }}
                          src={activeLogIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          {" "}
                          Audit Log{" "}
                        </div>
                      </div>
                    </li>
                  )}
                {activeRoutes &&
                  viewAllReportActiveRoutesPermission &&
                  viewAllReportActiveRoutesPermission.length > 0 && (
                    <li
                      className="text-white navlink reportSubMenu"
                      onClick={() => handleClick("activeRoutes")}
                    >
                      <div className="innerList">
                        <img
                          style={{
                            opacity:
                              window.location.search.split("?")[1] ==
                              "activeRoutes"
                                ? 1
                                : 1,
                          }}
                          src={activeRouteIcon}
                          alt="route"
                        />
                        <div className="text-white pl-2 font-weight-bolder">
                          {" "}
                          Active Routes{" "}
                        </div>
                      </div>
                    </li>
                  )}
                {localStorage.getItem("email") == "watsoo@watsoo.com" && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("upTime")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.search.split("?")[1] == "upTime"
                              ? 1
                              : 1,
                        }}
                        src={uptimeIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        {" "}
                        Up Time Report{" "}
                      </div>
                    </div>
                  </li>
                )}
                {gpsReport && (
                  <li
                    className="text-white navlink reportSubMenu"
                    onClick={() => handleClick("reportsgps")}
                  >
                    <div className="innerList">
                      <img
                        style={{
                          opacity:
                            window.location.pathname.split("/")[1] ==
                            "reportsgps"
                              ? 1
                              : 1,
                        }}
                        src={GpsIcon}
                        alt="route"
                      />
                      <div className="text-white pl-2 font-weight-bolder">
                        GPS Report{" "}
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </li>
          )}
          {/* <li className='showDivReport' onMouseOver={mouseOverForReportHandler} onMouseOut={mouseOutHandlerForReports}>
                    
    </li> */}
        </ul>
      )}

      {localStorage.getItem("email") == "route@watsoo.com" && (
        <div className="navlink " onClick={() => handleClick("routelist")}>
          <div style={{ width: "20px" }}>
            {" "}
            <img
              style={{
                opacity:
                  window.location.pathname.split("/")[1] == "routelist" ? 1 : 1,
              }}
              className="ml-1"
              src={routeIcon}
              alt="route"
            />
          </div>
          <div className="text-white ml-2 font-weight-bolder">
            Route Management{" "}
          </div>
        </div>
      )}

      <div style={{ position: "fixed", bottom: "0" }}>
        <div className=" ">
          <div></div>
          <div
            className="text-white font-weight-bolder text-center ml-1"
            style={{ fontSize: "10px" }}
          >
            Version {version}{" "}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
